import React, { createContext, useContext, useState, useCallback } from "react";

const STORAGE_KEY = "ark_credential";

interface AuthContextValue {
  credential: string | null;
  login: (credential: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [credential, setCredential] = useState<string | null>(() =>
    localStorage.getItem(STORAGE_KEY)
  );

  const login = useCallback((cred: string) => {
    localStorage.setItem(STORAGE_KEY, cred);
    setCredential(cred);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    setCredential(null);
  }, []);

  return (
    <AuthContext.Provider value={{ credential, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
